import React from "react";
import { styled } from "styled-components";
import fipayFonts from "../../theme/index";

interface SaveBeneficiaryProps {
  toggleIcon: string;
  Title: string;
  onClick: () => void;
}
const SaveBeneficiaryComponent: React.FC<SaveBeneficiaryProps> = ({
  toggleIcon,
  Title,
  onClick,
}) => {
  return (
    <BeneficiaryWrapper onClick={onClick}>
      <div>
        <span>{Title}</span>
      </div>
      <div>
        <img src={toggleIcon} alt="" />
      </div>
    </BeneficiaryWrapper>
  );
};

export default SaveBeneficiaryComponent;

export const BeneficiaryWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5rem;
  span {
    margin-bottom: 5px;
    font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
    font-family: "Gt Walsheim Pro", sans-serif;
    font-size: ${fipayFonts.fipayFonts.fontSize.body3};
    letter-spacing: 2%;
  }
`;
